var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    fill: "none",
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF0ED",
    fillRule: "evenodd",
    d: "M35.798 46.932c-.527-3.104-3.23-5.515-6.482-5.515h-2.618l6.058-3.634c1.742-1.046 2.329-3.292 1.32-5.056-1.026-1.797-3.32-2.416-5.112-1.378l-6.037 4.226c-3.802 2.201-5.065 7.09-2.804 10.856l4.16 8.775h18.043l2.758-8.273h-9.286z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#48E1BB",
    fillRule: "evenodd",
    d: "M40.059 46.933H26.208c-2.521 0-4.565-2.044-4.565-4.566V16.566c0-2.521 2.044-4.566 4.565-4.566h13.85c2.522 0 4.566 2.045 4.566 4.566v25.801c0 2.522-2.044 4.566-4.565 4.566z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M40.059 46.933H26.208c-2.521 0-4.565-2.044-4.565-4.566V16.566c0-2.521 2.044-4.566 4.565-4.566h13.85c2.522 0 4.566 2.045 4.566 4.566v25.801c0 2.522-2.044 4.566-4.565 4.566z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M26.238 19.355h13.79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#48E1BB",
    fillRule: "evenodd",
    d: "M37.73 19.355c0 1.015-.823 1.838-1.838 1.838-1.016 0-1.84-.823-1.84-1.838 0-1.016.824-1.839 1.84-1.839 1.015 0 1.838.823 1.838 1.84z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M37.73 19.355c0 1.015-.823 1.838-1.838 1.838-1.016 0-1.84-.823-1.84-1.838 0-1.016.824-1.839 1.84-1.839 1.015 0 1.838.823 1.838 1.84z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M26.238 25.79h13.79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#48E1BB",
    fillRule: "evenodd",
    d: "M34.053 25.79c0 1.015-.823 1.838-1.839 1.838-1.015 0-1.838-.823-1.838-1.839 0-1.015.823-1.838 1.838-1.838 1.016 0 1.839.823 1.839 1.838z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M34.053 25.79c0 1.015-.823 1.838-1.839 1.838-1.015 0-1.838-.823-1.838-1.839 0-1.015.823-1.838 1.838-1.838 1.016 0 1.839.823 1.839 1.838z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF0ED",
    fillRule: "evenodd",
    d: "M35.892 50.61v-2.617c0-3.632-2.945-6.575-6.577-6.575h-2.617l6.057-3.635c1.742-1.046 2.33-3.292 1.322-5.055-1.027-1.798-3.321-2.417-5.113-1.38l-6.037 4.227c-3.802 2.2-5.064 7.089-2.805 10.856l4.163 8.776h18.042l2.757-8.274",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M35.892 50.61v-2.617c0-3.632-2.945-6.575-6.577-6.575h-2.617l6.057-3.635c1.742-1.046 2.33-3.292 1.322-5.055-1.027-1.798-3.321-2.417-5.113-1.38l-6.037 4.227c-3.802 2.2-5.064 7.089-2.805 10.856l4.163 8.776h18.042l2.757-8.274"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF0ED",
    fillRule: "evenodd",
    d: "M40.582 40.268c-.762-1.32-.31-3.005 1.01-3.767l2.387-1.38c1.32-.761 3.006-.31 3.768 1.01s.31 3.006-1.01 3.768l-2.387 1.379c-1.32.76-3.006.309-3.768-1.01z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M40.582 40.268v0c-.762-1.32-.31-3.005 1.01-3.767l2.387-1.38c1.32-.761 3.006-.31 3.768 1.01s.31 3.006-1.01 3.768l-2.387 1.379c-1.32.76-3.006.309-3.768-1.01z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF0ED",
    fillRule: "evenodd",
    d: "M38.743 34.752c-.76-1.319-.31-3.005 1.01-3.767l2.388-1.379c1.32-.762 3.006-.31 3.767 1.01.762 1.32.31 3.005-1.009 3.767l-2.388 1.38c-1.32.76-3.006.308-3.768-1.01z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M38.743 34.752v0c-.76-1.319-.31-3.005 1.01-3.767l2.388-1.379c1.32-.762 3.006-.31 3.767 1.01.762 1.32.31 3.005-1.009 3.767l-2.388 1.38c-1.32.76-3.006.308-3.768-1.01z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF0ED",
    fillRule: "evenodd",
    d: "M41.568 45.898c-.786-1.363-.274-3.106 1.124-3.826l1.343-.692c1.306-.672 2.912-.202 3.646 1.072.787 1.363.275 3.105-1.124 3.827l-1.342.69c-1.307.675-2.912.203-3.647-1.07z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M41.568 45.898v0c-.786-1.363-.274-3.106 1.124-3.826l1.343-.692c1.306-.672 2.912-.202 3.646 1.072.787 1.363.275 3.105-1.124 3.827l-1.342.69c-1.307.675-2.912.203-3.647-1.07z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnApp);
export default __webpack_public_path__ + "static/media/AnApp.7d4ed3427f48237de574e53a0ae2df6e.svg";
export { ForwardRef as ReactComponent };